import { registerSsrGlobals } from "./ssr-register";

registerSsrGlobals();

// Legacy client-only mounting (jQuery plugins, non-SSR React roots).
if (typeof document === "undefined" || !(document as Document & { __isSSR?: boolean }).__isSSR) {
  void import("../index");
}
